/**
 * COMMENTED OUT: Storage Status Component - No database used in this system
 * This system uses DNA sequences for storage, no real-time status updates needed
 */

// import React, { memo } from 'react';
// import { Database, HardDrive, Activity, Wifi, WifiOff } from 'lucide-react';
// import { useWebSocket } from '../hooks/useWebSocket';

// const StorageStatus: React.FC = memo(() => {
//   const { 
//     isConnected, 
//     stats, 
//     lastUpdated, 
//     error, 
//     reconnect 
//   } = useWebSocket();

//   if (!stats) {
//     return (
//       <div className="card mb-8">
//         <div className="flex items-center justify-center gap-4">
//           <Activity className="text-gold animate-pulse" size={24} />
//           <span className="text-gold">Connecting to real-time updates...</span>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="card mb-8 border-red-500">
//         <div className="text-center">
//           <div className="text-red-500 mb-2">Connection Error</div>
//           <div className="text-sm text-gray-400 mb-4">{error}</div>
//           <button 
//             onClick={reconnect}
//             className="px-4 py-2 bg-gold text-black rounded hover:bg-yellow-400 transition-colors"
//           >
//             Reconnect
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="card mb-6">
//       <div className="card-header">
//         <div className="flex items-center justify-between">
//           <h2 className="text-xl font-bold text-gold flex items-center gap-2">
//             <Database size={24} />
//             Storage Status
//           </h2>
//           <div className="flex items-center gap-2">
//             {isConnected ? (
//               <Wifi size={16} className="text-green-400" />
//             ) : (
//               <WifiOff size={16} className="text-red-400" />
//             )}
//             <span className="text-xs text-gray-400">
//               {isConnected ? 'Live' : 'Disconnected'}
//             </span>
//           </div>
//         </div>
//         {lastUpdated && (
//           <div className="text-xs text-gray-400 mt-1">
//             Last updated: {new Date(lastUpdated).toLocaleTimeString()}
//           </div>
//         )}
//       </div>

//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
//         <div className="bg-black p-3 rounded-lg border border-gold">
//           <div className="flex items-center gap-2 mb-2">
//             <HardDrive size={18} className="text-gold" />
//             <span className="text-sm text-gray-400">Data Items</span>
//           </div>
//           <div className="text-xl font-bold text-gold">
//             {stats.totalDataItems}
//           </div>
//         </div>
//         
//         <div className="bg-black p-3 rounded-lg border border-gold">
//           <div className="flex items-center gap-2 mb-2">
//             <Database size={18} className="text-gold" />
//             <span className="text-sm text-gray-400">Storage Used</span>
//           </div>
//           <div className="text-xl font-bold text-gold">
//             {stats.totalStorageUsedMb.toFixed(2)} MB
//           </div>
//           <div className="text-xs text-gray-400">
//             ({stats.totalStorageUsedKb.toFixed(2)} KB)
//           </div>
//         </div>
//         
//         <div className="bg-black p-3 rounded-lg border border-gold">
//           <div className="flex items-center gap-2 mb-2">
//             <Activity size={18} className="text-gold" />
//             <span className="text-sm text-gray-400">DNA Sequences</span>
//           </div>
//           <div className="text-xl font-bold text-gold">
//             {stats.availableDnaSequences}
//           </div>
//         </div>
//         
//         <div className="bg-black p-3 rounded-lg border border-gold">
//           <div className="flex items-center gap-2 mb-2">
//             <Database size={18} className="text-gold" />
//             <span className="text-sm text-gray-400">Efficiency</span>
//           </div>
//           <div className="text-xs text-gold font-semibold">
//             {stats.storageEfficiency}
//           </div>
//         </div>
//       </div>
//       
//       <div className="mt-4 text-center text-sm text-gray-400">
//         Real-time WebSocket updates • No database required • DNA sequences only
//       </div>
//     </div>
//   );
// });

// StorageStatus.displayName = 'StorageStatus';

// COMMENTED OUT: Storage Status component disabled - no database used in this system
// This system uses DNA sequences for storage, no real-time status updates needed
const StorageStatus: React.FC = () => {
  return (
    <div className="card mb-6">
      <div className="card-header">
        <h2 className="text-xl font-bold text-gold flex items-center gap-2">
          <span className="text-gold">🧬</span>
          DNA Engraving System
        </h2>
      </div>
      <div className="text-center text-lg text-gray-400 py-4">
        No User's Data stored in the system. 
      </div>
    </div>
  );
};

export default StorageStatus;